const FilterButton = ({ text, isActive, onChange }) => {
    return (
        <button
            className={`rounded-full px-3.5 py-1.5 text-sm font-medium capitalize transition ${
                isActive
                    ? " bg-primary-500 text-white hover:opacity-[85%]"
                    : " bg-white text-gray-700 shadow-sm hover:bg-gray-50"
            }`}
            onClick={() => onChange(text)}
        >
            {text}
        </button>
    );
};

export default FilterButton;
